import { createFileRoute } from "@tanstack/react-router";
import VariantC from "@/components/funnel/variants/VariantC";
import { BRAND_META_DESCRIPTION, BRAND_NAME } from "@/components/inflow/brand";

export const Route = createFileRoute("/lp-c")({
  head: () => ({
    meta: [
      { title: `${BRAND_NAME} — Variant C` },
      { name: "description", content: BRAND_META_DESCRIPTION },
      { name: "robots", content: "noindex,nofollow" },
      { property: "og:title", content: `${BRAND_NAME} — Variant C` },
      { property: "og:description", content: BRAND_META_DESCRIPTION },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: VariantC,
});
